import map from 'lodash/map';
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import uuidV4 from 'uuid/v4';
import FormGroup from '@spothero/ui/form-group';
import Label from '@spothero/ui/label';
import Radio from '@spothero/ui/radio';
import RadioGroup from '@spothero/ui/radio-group';
import TextButton from '@spothero/ui/text-button';
import DOMUtils from '@spothero/utils/dom';
import Icon from 'common/icon/Icon';

export default class MultiRateChooser extends Component {
    static propTypes = {
        rates: PropTypes.array.isRequired,
        selectedRate: PropTypes.object.isRequired,
        onMultiRateChange: PropTypes.func.isRequired,
        onInfoButtonClick: PropTypes.func
    };

    constructor(props) {
        super(props);

        const {
            rates,
            selectedRate
        } = props;

        this.state = {
            rates,
            selectedRate,
            radioGroupKey: uuidV4()
        };
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        const {
            rates: nextRates,
            selectedRate: nextSelectedRate
        } = nextProps;
        const {
            rates,
            selectedRate
        } = prevState;

        if (nextRates[0].fullRule !== rates[0].fullRule) {
            return {
                rates: nextRates,
                radioGroupKey: uuidV4()
            };
        } else if (nextSelectedRate.fullRule !== selectedRate.fullRule) {
            return {
                radioGroupKey: uuidV4()
            };
        }

        return null;
    }

    _onRateChange = evt => {
        this.props.onMultiRateChange(parseInt(evt.target.value, 10));
    }

    _onInfoButtonClick = evt => {
        const radioContainer = DOMUtils.parent(evt.currentTarget, '.Radio');
        const value = parseInt(DOMUtils.attr(radioContainer.querySelector('input'), 'value'), 10);

        this.setState((prevState, props) => {
            return {
                rates: map(prevState.rates, rate => {
                    rate.checked = (value === rate.fullRule);

                    return rate;
                }),
                radioGroupKey: uuidV4()
            };
        });

        this.props.onMultiRateChange(value);
        this.props.onInfoButtonClick();
    }

    _renderInfoButton() {
        if (!this.props.onInfoButtonClick) { return null; }

        return (
            <TextButton
                onClick={this._onInfoButtonClick}
                iconPosition="left"
            >
                <Icon name="info" />
            </TextButton>
        );
    }

    render() {
        const {
            selectedRate
        } = this.props;
        const {
            rates,
            radioGroupKey
        } = this.state;

        return (
            <div className="MultiRateChooser">
                <FormGroup>
                    <RadioGroup
                        key={radioGroupKey}
                        id="MultiRateChooser-available-rates"
                        className="SelectRate"
                        name="available-rates"
                        onChange={this._onRateChange}
                    >
                        {map(rates, rate => {
                            return (
                                <Radio
                                    key={rate.fullRule}
                                    label={(
                                        <Label>
                                            <span
                                                dangerouslySetInnerHTML={{
                                                    __html: `${rate.price_formatted} - ${rate.title}`
                                                }}
                                            />
                                            {this._renderInfoButton()}
                                        </Label>
                                    )}
                                    value={`${rate.fullRule}`}
                                    defaultChecked={(selectedRate.fullRule === rate.fullRule)}
                                />
                            );
                        })}
                    </RadioGroup>
                </FormGroup>
            </div>
        );
    }
}
